// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Спросить HP Nio',
      close: 'Закрыть чат с Nio',
      open: 'Открыть чат с Nio',
      morningGreeting: "Доброе утро, {0}!",
      afternoonGreeting: "Добрый день, {0}!",
      eveningGreeting: "Добрый вечер, {0}!",
      morningGreetingGeneric: "Доброе утро!",
      afternoonGreetingGeneric: "Добрый день!",
      eveningGreetingGeneric: "Добрый вечер!",
      opening: "Меня зовут Nio. Чем я могу помочь?",
      openingPrivacy: "Меня зовут Nio.",
      pbIntro1: "Спросите меня о производительности вашего устройства.",
      alertDefault: "Я нахожусь на ранней стадии разработки, поэтому пока не могу ответить на некоторые вопросы (<b>{0}</b>)",
      intro2:  "Вот несколько вопросов, которые могут быть интересны:",
      kzIntro1: "Спросите меня о том, что вас беспокоит, и я предоставлю вам информацию из Области знаний.",
      pbSample1: "Насколько высокой вчера была производительность предприятия?",
      pbSample2: "Как можно повысить производительность?",
      pbSample3: "Какие печатные машины работают более эффективно по сравнению с другими?",
      pbSample4: "Использование какого носителя привело к наибольшим потерям времени?",
      pbSample5: "На решение какой проблемы я потратил больше всего времени на прошлой неделе?",
      kzSample1: "Как уменьшить отходы носителя, сохранив качество и сократив расходы?",
      kzSample2: "Какая печатная машина HP Indigo лучше всего подходит для эффективной печати этикеток для вина со стабильной цветопередачей?",
      kzSample3: "Как оптимизировать использование расходных материалов для повышения производительности?",
      kzSample4: "Какие основные факторы устойчивости следует учитывать при печати?",
      kzSample5: "Как обеспечить стабильность цветопередачи на моих печатных машинах HP Indigo 6000 и 20K?",
      feedbackTitle: "Обоснование вашей оценки",
      feedbackPlaceholder: "Можете ли вы подробно объяснить, что произошло?",
      fbPositive1: "Данные верные",
      fbPositive2: "Очень хороший ответ",
      fbPositive3: "Очень подробно",
      fbPositive4: "Ответ был релевантным",
      fbOther: "Другое",
      fbNegative1: "Информация или данные неверны",
      fbNegative2: "Я не получил ответа на мой вопрос",
      fbNegative3: "Ответ был запутанным или неясным",
      fbNegative4: "Ответ был нерелевантным",
      feedbackSubmittedTitle: "Благодарим за отзыв!",
      feedbackSubmittedDescription_Positive: "Приятно слышать, что ответ был полезен! Ваш отзыв вдохновляет нас продолжать предоставлять лучший опыт.",
      feedbackSubmittedDescription_Negative: "Приносим извинения за любые неудобства, которые это могло вызвать. Наша команда рассмотрит информацию и поработает над ее исправлением. Если у вас есть более подробная информация об ошибке или дополнительный отзыв, сообщите нам, чтобы помочь нам улучшить ее.",
      ask_Placeholder: "Что бы вы хотели узнать?",
      answerCopiedToClipboard: "Ответ скопирован в буфер обмена",
      feedbackSubmitted: "Отзыв отправлен",
      feedbackCleared: "Отзыв удален",
      newConversation: "Новый чат",
      chatHistory: "История чатов",
      submitQuestion: "Отправить вопрос",
      responseError: "Ой, похоже, возникла проблема с нашей стороны.  Повторите попытку позже.  Если проблема сохранится, обратитесь в службу поддержки.",
      responseError400: "Похоже, ваш вопрос содержит неожиданные символы. Удалите их, чтобы продолжить.",
      responseError429: "Ой, помедленнее. Я не успеваю отвечать на столько вопросов.",
      like: "Нравится",
      dislike: "Не нравится",
      copy: "Копировать в буфер обмена",
      retry: "Повтор",
      contact: "Контакты",
      contactSubject: "Проблема с HP Nio",
      contactQuestion: "Вопрос: {0}",
      noConversations: "У вас нет бесед",
      startConversation: "Начните беседу, чтобы просмотреть здесь историю чатов",
      today: "Сегодня",
      yesterday: "Вчера",
      privacyNotice: "Вы собираетесь взаимодействовать с решением на основе технологий ИИ",
      privacy1: "Вы собираетесь взаимодействовать с решением на основе технологий ИИ. Чаты могут быть просмотрены и использованы для обучения наших моделей.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Начать чат с HP Nio"
    },
    apps: {
      title: "Меню",
      externalLinks: "Внешний",
      availableApps: "Знакомство",
      configure: "Настройка",
      showApp: "Отобразить",
      hideApp: "Скрыть",
      setDefault: "Задать приложение по умолчанию",
      setShortcut: "Закрепить",
      removeShortcut: "Открепить",
      showAllApps: "Показать все приложения",
      shortCutTooltip: "Перейти к {0}",
      currentAccount: "Текущая организация",
      goHome: "На главную",
      goAppHome: "Перейти на начальную страницу приложения",
      byProvider: "от {0}",
      quickFilter: "Найти приложение...",
      allApps: "Все приложения",
      recentApps: "Последние",
      externalApp: "Приложение, внешнее по отношению к PrintOS",
      modeSwitcher: "Темный/светлый режим",
      goProducts: "Обзор других приложений"
    },
    panels: {
      ai: "Спросить HP Nio",
      notifications: "Мои уведомления",
      help: "Справка и поддержка",
      user: "Пользователь",
      close: "Закрыть панель",
      moveLeft: "Переместить влево",
      moveRight: "Переместить вправо",
      maximize: "Максимально",
      restore: "Восстановить",
    },
    user: {
      account: "Организация",
      returnToHP: "Вернуться на сайт HP Inc.",
      myOrganization: "Моя организация",
      myOrganizations: "Мои организации",
      myReports: "Мои отчеты",
      mySettings: "Мои настройки",
      signOut: "Выход",
      signInExplanation: "Войдите в HP PrintOS, чтобы просмотреть уведомления и приложения.",
      signIn: "Вход",
      RCDA: "Доступ заказчика",
      orphanUser: "Пользователь PrintOS",
      orphanContext: "Нет организаций",
      deviceUser: "Устройство PrintOS",
      anonymous: "Анонимный пользователь",
      name: "Название",
      email: "Эл. почта",
      address: "Адрес",
      editUser: "Изменить учетную запись HP",
      viewPrivacy: "Просмотреть заявление о конфиденциальности"
    },
    date: {
      fewSecondsAgo: "Несколько секунд назад",
      minuteAgo: "Минуту назад",
      minutesAgo: "{0} мин назад",
      hourAgo: "Час назад",
      hoursAgo: "{0} час. назад",
      dayAgo: "День назад",
      daysAgo: "{0} дн. назад",
      monthAgo: "Месяц назад",
      monthsAgo: "{0} мес. назад",
      yearAgo: "Год назад",
      yearsAgo: "{0} года назад",
    },
    help: {
      quickFilter: "Поиск",
      page: "Стр.",
      app: "Приложение",
      newFeatures: "Новые функции",
      more: "Все",
      contactHP: "Связь с HP",
      noTopics: "Нет соответствующих разделов справки",
      about: "О программе",
      terms: "Условия обслуживания",
      readFile: "Документ",
      stepByStepTutorial: "Пособие",
      goLink: "Страница приложения",
      viewVideo: "Видео",
      goToUrl: "Ссылка",
      other: "Другое",
      faq: "Часто задаваемые вопросы",
      new: "Новая тема",
      whatsNew: "Что нового?",
      technicalSupport: "Служба поддержки PrintOS",
      printOSFeedback: "Отзыв по PrintOS",
      conversationsWithHP: "Общение с HP",
      youMayConsider: "Предлагается к рассмотрению...",
      myKzArticles: "Мои статьи в области знаний",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Статьи центра знаний HP Latex",
    },
    notifications: {
      noNotifications: "Нет уведомлений",
      viewAll: "Просмотреть все",
      dismiss: "Отклонить",
      dismissAll: "Отклонить все",
      subscriptions: "Параметры",
    },
    marketplace: {
      title: "Рынок",
      explore: "Просмотреть все",
      featured: "Популярные",
      slides: {
        default: {
          description: "Улучшение PrintOS с помощью первоклассных приложений, расширений и соединителей"
        },
        oee: {
          title: "OEE для Print Beat",
          description: "Оптимизация производства путем оперативного получения аналитических данных",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "С 4 августа для доступа к службам Indigo Print Beat, Jobs, OEE и Print Beat потребуется <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>подписка на Productivity Power Pack</a>.",
      partialProductivitySubscribePreEnforcement_Desc: "Данные с устройств без подписки можно будет извлечь до августа.",
      partialProductivitySubscribePostEnforcement_Title: "Подписка на Productivity Power Pack оформлена не для всех устройств Indigo ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Возможности в PrintOS (Print Beat, задания, OEE, рабочие панели, ...) для устройств без подписки могут быть ограничены",
      goToMarket_Action: "Посетить рынок",
      howToExtract_Action: "Как извлечь данные"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "Немецкий",
      "en-GB": "Английский (Великобритания)",
      "en-US": "Английский (США)",
      "es-ES": "Испанский",
      "fr-FR": "Французский",
      "it-IT": "Итальянский",
      "ja-JP": "Японский",
      "ko-KO": "Корейский",
      "pt-PT": "Португальский",
      "tr-TR": "Турецкий",
      "zh-HANS": "Китайский (упрощенный)",
      "ru-RU": "Русский",
      "PartialTranslation": "Частичные переводы",
    },
    modal: {
      ok: "OK",
      cancel: "Отмена",
    },
    combo: {
      noItems: "Соответствий не найдено",
    },
    nps: {
      question: "Здравствуйте, {0}. Какова вероятность того, что вы порекомендуете PrintOS коллегам?",
      // In case we can't get user's display name
      questionNameless: "Какова вероятность того, что вы порекомендуете PrintOS коллегам?",
      notLikely: "Мало вероятно",
      likely: "Очень вероятно",
      send: "Отправить отзыв",
      response: {
        detractor: "{0}, назовите что-то одно, что мы можем сделать, чтобы улучшить работу PrintOS. Мы читаем все комментарии.",
        detractorNameless: "Назовите что-то одно, что мы можем сделать, чтобы улучшить работу PrintOS. Мы читаем все комментарии.",
        passive: "{0}, расскажите, что мы можем сделать, чтобы сделать PrintOS еще лучше. Мы читаем все комментарии.",
        passiveNameless: "Расскажите, что мы можем сделать, чтобы сделать PrintOS еще лучше. Мы читаем все комментарии.",
        promoter: "{0}, мы рады узнать, что вам нравится PrintOS! Расскажите, почему. Мы читаем все комментарии.",
        promoterNameless: "Мы рады узнать, что вам нравится PrintOS! Расскажите, почему. Мы читаем все комментарии.",
      },
      introMorning: "Доброе утро, {0}! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      introMorningNameless: "Доброе утро! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      introAfternoon: "Добрый день, {0}! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      introAfternoonNameless: "Добрый день! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      introEvening: "Добрый вечер, {0}! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      introEveningNameless: "Добрый вечер! Меня зовут Йон, я - менеджер по развитию и оптимизации взаимодействия с заказчиками PrintOS.",
      intro2: "Поделитесь, пожалуйста, своим мнением о PrintOS, ответив на вопрос:",
      intro3: "Какова вероятность того, что вы порекомендуете PrintOS коллегам?",
      detractorResponse: "Благодарю за ответ, {0}! Мы высоко ценим и положительное мнение, и критику.",
      detractorResponseNameless: "Благодарим за ответ! Мы высоко ценим и положительное мнение, и критику.",
      promoterResponse: "Спасибо, {0}! Приятно узнать ваше высокое мнение о PrintOS. Ваш отзыв все равно поможет нам внести улучшения.",
      promoterResponseNameless: "Спасибо! Приятно узнать ваше высокое мнение о PrintOS. Ваш отзыв все равно поможет нам внести улучшения.",
      response2: "Выберите приложение и расскажите, как мы можем сделать PrintOS еще лучше.",
      response3: "Все комментарии внимательно анализируются нашими менеджерами по развитию и оптимизации взаимодействия с заказчиками. Наши специалисты могут связаться с вами, если потребуются уточнения по отзыву.",
      feedbackPlaceholder: "Вы можете сделать PrintOS лучше...",
      application: "Приложение",
      noApplication: "PrintOS - общий отзыв"
    },
    subscription: {
      title: "Подписка",
      subscribe: "Подпишитесь прямо сейчас!",
      noticeSingular: "Подписка {0} истекает через {1} дн.",
      notice: "Подписка {0} истекает через {1} дн.",
    },
    promotion: {
      label: "Рекламное предложение",
      title: "Уведомление о периоде действия предложения",
      notice: "Для вас действует специальное предложение по данному приложению.",
    },
    trial: {
      label: "Срок действия пробной версии скоро истечет",
      title: "Пробный период",
      noticeSingular: "Для {0} действует пробный период. Он истекает через {1} день.",
      notice: "Для {0} действует пробный период. Он истекает через {1} дн.",
    },
    subscriptionExpired: {
      label: "Срок подписки истек",
      title: "Срок подписки истек",
      notice: "Срок вашей подписки {0} истек.  После небольшого льготного периода доступ к этой функциональной возможности будет прекращен.",
    },
    trialExpired: {
      label: "Срок пробной версии истек",
      title: "Время пробного периода истекло",
      notice: "Пробный период для {0} истек.  После небольшого льготного периода доступ к этой функциональной возможности будет прекращен.",
    },
    hpWarning: "{0}\nВы являетесь представителем HP Inc. в организации заказчика.  Будьте внимательны.",
    role: {
      HP_Operation: "Операции HP",
      HP_Sales_and_Marketing: "Материалы HP для клиентов",
      SystemRoleGenesis_Admin: "Администратор услуг PrintOS",
      SystemRoleGenesis_Support: "Администратор HP Inc.",
      SystemRoleGenesis_R_AND_D: "Отдел исследований и разработок Genesis",
      CE_Level_1: "CE, уровень 1",
      CE_Level_2: "CE, уровень 2",
      Application_Engineer: "Инженер по эксплуатации",
      Ramp_Up_Engineer: "Инженер по выводу оборудования на рабочий режим",
      Support_Engineer: "Инженер службы поддержки",
      Remote_Support_Engineer: "Специалист по поддержке HP",
      Specialist: "Специалист",
      Certification_Centers: "Центры сертификации",
      Supplies_and_Media_Personnel: "Персонал отдела расходных материалов и носителей",
      Supplies_and_Media_Admin: "Администратор расходных материалов и носителей",
      HP_Service: "Обслуживание HP",
      HP_Training: "Обучение HP",
      Admin: "Администратор",
      Pre_Press_Operator: "Пользователь",
      Press_Operator: "Оператор",
      Dashboard: "Рабочая панель",
      Channel_Sales_and_Marketing: "Каналы сбыта и маркетинг",
      Channel_Operation: "Работа с партнерами",
      Channel_CE_Level_1: "Инженер по ТО торгового партнера, уровень 1",
      Channel_CE_Level_2: "Инженер по ТО торгового партнера, уровень 2",
      HP_Read_Only: "HP, только для чтения",
      Reseller_Manager: "Менеджер по работе с реселлерами",
      Business_Partner_Manager: "Менеджер по работе с партнерами",
      Call_Center: "Операторский центр",
      Field_Engineer: "Инженер по эксплуатации",
      ThreeD_Business_Manager: "Директор по 3D-решениям",
      HPInPsp: "Представитель HP в организации поставщика услуг печати",
      ChannelInPsp: "Представитель торгового партнера в организации поставщика услуг печати",
      GenericAdmin: "Администратор",
      GenericUser1: "Уровень пользователя 1",
      GenericUser2: "Уровень пользователя 2",
      Generic_Read_Only: "Только для чтения",
      ThreeD_Care_Center: "Центр поддержки 3D Care Center",
      ThreeD_Cost_Calculator: "3D Costing",
      Composer_External: "Ограниченный доступ - Composer",
      SIM_External: "Ограниченный доступ - диспетчер запасов расходных материалов",
      Multiple: "Несколько ролей"
    },
    inlineAlerts: {
      Http_429_Error: "Высокий трафик",
      Http_429_Description: "В настоящее время служба работает с необычно высокой загрузкой.  Некоторые функции могут быть временно недоступны.  Обновите страницу, чтобы повторить попытку",
      Http_429_Action: "Обновить",
      NewSubscription: "Новая подписка — {0}",
      NewSubscriptionDescription: "У вашей организации имеется новая подписка",
      NewSubscriptionAction: "Подробнее",
      SubscriptionExpired: "Срок действия подписки истек — {0}",
      SubscriptionExpiredDescription: "Срок действия подписки истек {0}",
      SubscriptionExpiredAction: "Просмотреть подписку",
      Subscription30DayWarning: "Срок действия подписка истекает {0}",
      Subscription30DayWarningDescription: "Срок действия подписки истекает через {0} дн. — {1}",
      Subscription30DayWarningAction: "Просмотреть подписку",
      Subscription15DayWarning: "Срок действия подписки скоро закончится — {0}",
      Subscription15DayWarningDescription: "Срок действия подписки истекает через {0} дн. — {1}",
      Subscription15DayWarningAction: "Просмотреть подписку",
      JoinOrgRequestAccepted: "Запрос на вступление в организацию принят",
      JoinOrgRequestAcceptedDescription: "Вам предоставлен доступ к <b>{0}</b>",
      JoinOrgRequestSwitch: "Открыть организацию",
      JoinOrgRequestDenied: "Запрос на вступление в организацию отклонен",
      JoinOrgRequestDeniedDescription: "Администратор отклонил ваш запрос на вступление в <b>{0}</b>",
      NonHPContext: "Открыть контекстное окно не HP",
      NonHPContextDescription: "Контекст: {0}",
      CloseContext: "Закрыть контекст"
    },
    ui: {
      Confirm: "Подтвердить",
      Notify: "Уведомление",
      OpenImage: "Открыть файл изображения",
      Dismiss: "Отклонить",
      CheckingContext: "Проверка контекста...",
      LoadingContext: "Восстановление {0}..."
    }
  }
};
